export default "__VITE_ASSET__CTgOrwy0__"